export default "__VITE_ASSET__moxMPzt2SkBPQ20CK_dFDg__";